import { OrganisationStructureFilter } from 'const';
import { useMemo } from 'react';
import { RouteObject, matchRoutes } from 'react-router';

export const useRouteOrganisationContextFilter = (routes: RouteObject[]) => {
  type MatchedRouteWithFilters = { route: { filters?: OrganisationStructureFilter[] } };
  const matchedRoute = matchRoutes(routes, location) as MatchedRouteWithFilters[];

  const filters = useMemo(
    () => matchedRoute?.flatMap((x) => x.route?.filters ?? []).filter((x) => x !== undefined),
    [matchedRoute]
  );

  return filters;
};
